// extracted by mini-css-extract-plugin
export default {"melodyVideo":"RH-z","isFullWidth":"SH-z","landingPageVideo":"TH-z","play":"UH-z","iframeVideo":"VH-z","playHidden":"WH-z","fullwidth":"XH-z"};